import React from 'react';
import PropTypes from 'prop-types';

const PrivacyDisclosure = ({ isValidVertical, isUSA, companyFullName }) => {
  if (!isValidVertical || !isUSA) {
    return null;
  }

  return (
    <div className="row">
      <div className="col text-left" style={{ paddingBottom: 10, fontSize: 12 }}>
        By subscribing, you agree to receive marketing communications from {companyFullName}.
        They are solely responsible for the content and management of your personal information.
        This service is powered by OutboundEngine. As the platform provider, OutboundEngine
        commits to never selling your personal information, as detailed in our{' '}
        <a href="https://www.outboundengine.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>.
      </div>
    </div>
  );
};

PrivacyDisclosure.propTypes = {
  isValidVertical: PropTypes.bool.isRequired,
  isUSA: PropTypes.bool.isRequired,
  companyFullName: PropTypes.string.isRequired,
};

export default PrivacyDisclosure;
